var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"modal-select",attrs:{"type":"time"},domProps:{"value":_vm.time},on:{"change":function($event){return _vm.onChange($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }